import * as React from 'react';
import { cn } from '@/lib/utils';
import ButtonPrime from '@/components/navigation/ButtonPrime';
import { Link } from 'react-router-dom';

const FeatureCards = ({title, description, buttonText, icon, className, onClick, alt}) => {


  return (
    <div className={cn("text-center rounded-3xl  px-2 xl:mx-2 ring bg-prime-950 flex flex-col justify-between py-10 items-center", className)}>
      <div className='flex flex-col justify-center items-center'>
        <img src={icon} alt={alt} className='size-14 mb-7' />
      
        <h2 className='font-sans font-medium text-2xl mb-3 text-prime-50'>
          {title}
        </h2>
        <p className='text-gray-300 pb-7  md:min-h-[5rem] max-w-[15rem] font-sans'>
          {description}
        </p>
      </div>
      <div>
        <Link to={onClick}>
        <ButtonPrime className="xl:min-w-[15rem] min-w-[10rem]" >
          {buttonText}
        </ButtonPrime>
        </Link>
      </div>
    </div>
  );
};

export default FeatureCards;
